define('OutSystems/ClientRuntime/CSSHelper',["require", "exports", "./Logger"], function (require, exports, Logger) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getIgnoreLoadErrors = exports.setIgnoreLoadErrors = exports.scheduleCSSPreparation = exports.hasClass = exports.conditionClass = exports.removeClass = exports.addClass = void 0;
    var CSS_HELPER_MODULE_NAME = "CSSHelper";
    function addClass(element, className) {
        if (className) {
            if (element.classList) {
                element.classList.add(className);
            }
            else if (!hasClass(element, className)) {
                element.className = element.className + " " + className;
            }
        }
        return element;
    }
    exports.addClass = addClass;
    function removeClass(element, className) {
        if (className) {
            if (element.classList) {
                element.classList.remove(className);
            }
            else if (hasClass(element, className)) {
                element.className = element.className
                    .replace(new RegExp("(^|\\s)" + className + "(?:\\s|$)", "g"), "$1")
                    .replace(/\s+/g, " ")
                    .replace(/^\s*|\s*$/g, "");
            }
        }
        return element;
    }
    exports.removeClass = removeClass;
    function conditionClass(element, className, condition) {
        return (condition ? addClass : removeClass)(element, className);
    }
    exports.conditionClass = conditionClass;
    function hasClass(element, className) {
        if (element.classList) {
            return !!className && element.classList.contains(className);
        }
        return (" " + element.className + " ").indexOf(" " + className + " ") > -1;
    }
    exports.hasClass = hasClass;
    var lastDiffTimestamp = 0;
    function scheduleCSSPreparation(urls, onError) {
        if (urls.length === 0) {
            return {
                loadStylesPromise: Promise.resolve(),
                triggerRemoveStyles: function () { },
            };
        }
        var head = document.head || document.querySelector("head");
        var existingStyles = [].slice.call(document.querySelectorAll("link[data-os]") || []).reverse();
        var stylesBeingLoaded = [];
        var stylesToRetain = [];
        var stylesToAdd = [];
        var lastAddedStyle = undefined;
        var resumeOffIndex = 0;
        iterateUrls: for (var _i = 0, _a = urls.reverse(); _i < _a.length; _i++) {
            var url = _a[_i];
            for (var i = resumeOffIndex; i < existingStyles.length; i++) {
                var style_1 = existingStyles[i];
                if (style_1.id === url) {
                    lastAddedStyle = style_1;
                    stylesToRetain.push(style_1);
                    resumeOffIndex = i + 1;
                    continue iterateUrls;
                }
            }
            var style = loadStylesheet(url, stylesBeingLoaded, onError);
            stylesToAdd.push({ beforeElement: lastAddedStyle, element: style });
            lastAddedStyle = style;
        }
        traceLength("Adding", stylesToAdd);
        for (var _b = 0, stylesToAdd_1 = stylesToAdd; _b < stylesToAdd_1.length; _b++) {
            var _c = stylesToAdd_1[_b], beforeElement = _c.beforeElement, element = _c.element;
            traceStylesheet("Adding", element.id);
            if (beforeElement) {
                head.insertBefore(element, beforeElement);
            }
            else {
                head.appendChild(element);
            }
        }
        lastDiffTimestamp += 1;
        var removalTimestamp = lastDiffTimestamp;
        var removeStyles = function () {
            if (lastDiffTimestamp !== removalTimestamp) {
                return;
            }
            traceLength("Retaining", stylesToRetain);
            for (var _i = 0, stylesToRetain_1 = stylesToRetain; _i < stylesToRetain_1.length; _i++) {
                var styleToRetain = stylesToRetain_1[_i];
                traceStylesheet("Retaining", styleToRetain.id);
            }
            for (var _a = 0, existingStyles_1 = existingStyles; _a < existingStyles_1.length; _a++) {
                var stylesheet = existingStyles_1[_a];
                if (stylesheet.parentNode && stylesToRetain.indexOf(stylesheet) === -1) {
                    traceStylesheet("Removing", stylesheet.id);
                    stylesheet.parentNode.removeChild(stylesheet);
                }
            }
        };
        return {
            loadStylesPromise: Promise.all(stylesBeingLoaded),
            triggerRemoveStyles: removeStyles,
        };
    }
    exports.scheduleCSSPreparation = scheduleCSSPreparation;
    function traceLength(action, styles) {
        Logger.trace(CSS_HELPER_MODULE_NAME, action + " " + styles.length + " stylesheets : document '" + document.baseURI + "':");
    }
    function traceStylesheet(action, stylesheet) {
        Logger.trace(CSS_HELPER_MODULE_NAME, action + " stylesheet '" + stylesheet + "' : document '" + document.baseURI + "'");
    }
    var ignoreLoadErrors = false;
    function setIgnoreLoadErrors(value) {
        Logger.trace(CSS_HELPER_MODULE_NAME, "Setting ignore load errors to " + value);
        ignoreLoadErrors = value;
    }
    exports.setIgnoreLoadErrors = setIgnoreLoadErrors;
    function getIgnoreLoadErrors() {
        return ignoreLoadErrors;
    }
    exports.getIgnoreLoadErrors = getIgnoreLoadErrors;
    function loadStylesheet(cssURL, styleheetsBeingLoaded, onError) {
        Logger.trace(CSS_HELPER_MODULE_NAME, "Loading stylesheet '" + cssURL + "'");
        var style = document.createElement("link");
        style.type = "text/css";
        style.rel = "stylesheet";
        style.id = cssURL;
        style.href = cssURL;
        style.setAttribute("data-os", "true");
        styleheetsBeingLoaded.push(new Promise(function (resolve) {
            style.onerror = style.onabort = function (ev) {
                if (!ignoreLoadErrors) {
                    onError("Error loading stylesheet: " + cssURL);
                }
                else {
                    Logger.trace(CSS_HELPER_MODULE_NAME, "Ignored error while loading stylesheet '" + cssURL + "'");
                }
                style.parentNode.removeChild(style);
                resolve(ev);
            };
            style.onload = resolve;
        }));
        return style;
    }
});
//# sourceMappingURL=CSSHelper.js.map;
